<template lang="jade">
    include ../../node_modules/tangram-ui/src/elements/tge-svg-icons/tge-svg-icons.jade
    transition(appear, name="fade")
        .election_loading(:class="{ loading: loading }")
            +tge-svg-icons({ icon: "loader" })

</template>

<script>
export default {
    name: 'loading-overlay',
    props: ['loading']
}
</script>

<style lang="scss">
    @import "src/_commons/assets/scss/global-sass";
    .election_loading {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(0,0,0,0.8);
        border-radius: $m-spacing;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        padding: $m-spacing-x2;

        display: none;
        &.loading {
            display: flex;
        }

        .tge-svg-icon {
            width: 40px;
            height: 40px;
            rect {
                fill: #fff;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// LoadingOverlay.vue?e2820c38